export default __webpack_public_path__ + "static/media/grocery-store.20f17dd8.svg";